module.exports = __webpack_public_path__ + "static/media/icon-gdpr-1.142b9d40.png";